var render, staticRenderFns
import script from "./new_product_apply.vue?vue&type=script&lang=js"
export * from "./new_product_apply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ae2429')) {
      api.createRecord('59ae2429', component.options)
    } else {
      api.reload('59ae2429', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/new_product_apply/new_product_apply.vue"
export default component.exports